export default __webpack_public_path__ + "static/media/montagem1.e193087c.png";